import { Checkbox, Icon, Text, HStack } from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import { Button } from 'native-base';

interface BarSelectedItemsProps {
  countSelected: number;
  onBatchAction: (action: 'block' | 'unblock') => void;
  handleSelecteItems?: (value: string) => void;
  isSelectAll?: boolean;
}

export const BarSelectedItemsTablet = ({
  countSelected,
  onBatchAction,
  handleSelecteItems,
  isSelectAll,
}: BarSelectedItemsProps) => {
  return (
    <HStack
      bg={Utils.ColorToken.WithOpacity('feedback.gen.lightest', 0.45)}
      px={Spacing['inline.xxxs']}
      my={Spacing['inline.nano']}
      justifyContent="space-between"
      alignItems="center"
      borderRadius={BoxRadius.sm}>
      <HStack space={Spacing['inline.xxs']}>
        <HStack space={Spacing['inline.quarck']} alignItems="center" justifyContent="center">
          <Checkbox
            optionPadding={{ bottom: 0, right: 0 }}
            options={[{ label: '', value: 'select-all' }]}
            onChange={(value) => handleSelecteItems?.(value)}
            testId="checkbox-select-all"
            selectedValues={isSelectAll ? ['select-all'] : []}
          />
          <Text
            variant="semibold"
            fontSize={Typography['fontsize.sm']}
            color={Color['brand.tertiary.principal']}>
            Selecionar todos
          </Text>
        </HStack>

        <Button
          variant="textLink"
          color={'brand.tertiary.principal'}
          onPress={() => onBatchAction('block')}
          px={0}
          _text={{
            fontSize: Typography['fontsize.sm'],
            fontWeight: Typography['fontweight.semibold'],
          }}
          leftIcon={<Icon name="Cancel" size="xxxs" color={Color['brand.tertiary.principal']} />}>
          Bloqueio em lote
        </Button>
        <Button
          variant="textLink"
          color={'brand.tertiary.principal'}
          onPress={() => onBatchAction('unblock')}
          px={0}
          _text={{
            fontSize: Typography['fontsize.sm'],
            fontWeight: Typography['fontweight.semibold'],
          }}
          leftIcon={<Icon name="Refresh" size="xxxs" color={Color['brand.tertiary.principal']} />}>
          Desbloqueio em lote
        </Button>
      </HStack>
      <HStack space={Spacing['inline.quarck']}>
        <Text variant="semibold" fontSize={Typography['fontsize.md']} color={Color['neutral.dark']}>
          {countSelected}
        </Text>
        <Text variant="regular" fontSize={Typography['fontsize.md']} color={Color['neutral.dark']}>
          produtos selecionados
        </Text>
      </HStack>
    </HStack>
  );
};
